export default __webpack_public_path__ + "static/media/1.882babf2.png";